"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const ui_1 = require("react-science/ui");
const SpectraManager_1 = require("../../data/SpectraManager");
const ActionButtons_1 = __importDefault(require("../elements/ActionButtons"));
const FormikCheckBox_1 = __importDefault(require("../elements/formik/FormikCheckBox"));
const FormikSelect_1 = __importDefault(require("../elements/formik/FormikSelect"));
const Alert_1 = require("../elements/popup/Alert");
const initValues = {
    onlyReal: true,
    dataExportStage: 'PROCESSED',
};
const styles = {
    container: {
        width: '25em',
        padding: '1.5em 3em',
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        display: 'flex',
        paddingBottom: '0.5em',
    },
    label: {
        flex: 6,
        fontSize: '1em',
        fontWeight: 'bold',
    },
    innerContainer: {
        flex: 6,
        justifyContent: 'flex-start',
    },
};
const DATA_STAGES = Object.keys(SpectraManager_1.DataExportStage).map((key) => ({
    label: key,
    value: SpectraManager_1.DataExportStage[key],
}));
function ExportAsJcampModal(props) {
    const { closeDialog, spectrum } = props;
    const refForm = (0, react_1.useRef)(null);
    const alert = (0, Alert_1.useAlert)();
    function submitHandler(options) {
        void (async () => {
            const hideLoading = await alert.showLoading('export as JCAMP in progress');
            try {
                (0, SpectraManager_1.exportAsJcamp)(spectrum, options);
            }
            catch (error) {
                alert.error(error.message);
            }
            finally {
                closeDialog?.();
                hideLoading();
            }
        })();
    }
    return ((0, jsx_runtime_1.jsxs)(ui_1.Modal, { hasCloseButton: true, isOpen: true, onRequestClose: closeDialog, children: [(0, jsx_runtime_1.jsx)(ui_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)("span", { children: "Export as JCAMP" }) }), (0, jsx_runtime_1.jsx)(ui_1.Modal.Body, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: refForm, initialValues: initValues, onSubmit: submitHandler, children: (0, jsx_runtime_1.jsxs)("div", { style: styles.container, children: [(0, jsx_runtime_1.jsxs)("div", { style: styles.row, children: [(0, jsx_runtime_1.jsx)("span", { style: styles.label, children: " Data " }), (0, jsx_runtime_1.jsx)("div", { style: styles.innerContainer, children: (0, jsx_runtime_1.jsx)(FormikSelect_1.default, { name: "dataExportStage", items: DATA_STAGES, style: { width: '100%' } }) })] }), (0, jsx_runtime_1.jsxs)("div", { style: styles.row, children: [(0, jsx_runtime_1.jsx)("span", { style: styles.label, children: " Only real " }), (0, jsx_runtime_1.jsx)("div", { style: styles.innerContainer, children: (0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { name: "onlyReal" }) })] })] }) }) }) }), (0, jsx_runtime_1.jsx)(ui_1.Modal.Footer, { children: (0, jsx_runtime_1.jsx)("div", { style: { display: 'flex', justifyContent: 'flex-end' }, children: (0, jsx_runtime_1.jsx)(ActionButtons_1.default, { style: { flexDirection: 'row-reverse', margin: 0 }, onDone: () => refForm.current?.submitForm(), doneLabel: "export", onCancel: () => {
                            closeDialog?.();
                        } }) }) })] }));
}
exports.default = ExportAsJcampModal;
